export default __webpack_public_path__ + "static/media/prampe.e2d23f93.jpg";